
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36.67 36.67"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"var(--secondary-lighter)","opacity":".8","d":"M6.6 9.51h8.61v17.65H6.6zM16.34 18.77h13.73v8.38H16.34zM16.34 9.51h13.73v8.38H16.34z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/layoutIcons/layoutSelectionButton.svg